const init = () => {
    document.querySelectorAll('.load-more-spectacles').forEach(button => {
        button.addEventListener('click', () => {
            const container = button.closest('.js-load-more')
            const hiddenItems = container.querySelectorAll('.js-load-more-item.hidden')
            
            // Afficher tous les éléments cachés
            hiddenItems.forEach(item => {
                item.classList.remove('hidden')
            })

            // Masquer le bouton car tous les éléments sont maintenant affichés
            button.style.display = 'none'
        })
    })
}

document.addEventListener('DOMContentLoaded', init)
document.addEventListener('NewContentLoaded', init) 